var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "nav",
        { staticClass: "navbar navbar-expand navbar-light fixed-top" },
        [
          _c("div", { staticClass: "container" }, [
            _c("a", { staticClass: "navbar-brand", attrs: { href: "#" } }, [
              _c("img", {
                staticClass: "d-block",
                attrs: { src: "/img/LogoPortoBank1.svg", height: "23vh" },
                on: {
                  click: function ($event) {
                    return _vm.clickLogo()
                  },
                },
              }),
            ]),
            _vm._m(0),
            _vm._m(1),
          ]),
        ]
      ),
      _c("router-view"),
      _vm._m(2),
      _c(
        "a",
        {
          staticClass: "whatsapp-link",
          attrs: {
            href: "https://porto.vc/whatsapp-oficial",
            target: "_blank",
          },
          on: { click: _vm.saveLogcontatoWhatsApp },
        },
        [
          _c("i", {
            class: [
              _vm.largura < 500
                ? "fa fa-whatsapp fa-2x"
                : "fa fa-whatsapp fa-3x",
            ],
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "navbar-toggler navbar-toggler-right border-0 collapsed",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbar4",
          "aria-expanded": "false",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon small" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "navbar-collapse collapse", attrs: { id: "navbar4" } },
      [
        _c("p", { staticClass: "small text-info title-space mb-2 mt-2" }, [
          _vm._v(" Negocie Porto Bank "),
        ]),
        _c("ul", { staticClass: "navbar-nav ml-auto text-center" }),
        _c("div", { staticClass: "space1 d-none d-sm-block" }),
        _c("div", { staticClass: "text-center" }, [
          _c(
            "a",
            { staticClass: "btn btn-zul ml-auto", attrs: { href: "#" } },
            [_vm._v("Negociar")]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "footer1 text-light py-4",
        staticStyle: { background: "#000" },
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-lg-5" }),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }